import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MyPrivilegesComponent } from './components/my-privileges/my-privileges.component';
import { ModalComponent } from './components/modal/modal.component';
import { AccessManagementPipe } from './pipes/access-management.pipe';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { LoaderComponent } from './components/loader/loader/loader.component';
import { PopUpDirective } from './directives/pop-up.directive';
import { DateFormatDirective } from './directives/date-format.directive';
import { BscSvgIconComponent } from './svg-icon/bsc-svg-icon.component';

@NgModule({
  declarations: [
    MyPrivilegesComponent,
    ModalComponent,
    AccessManagementPipe,
    PaginationComponent,
    SafeHtmlPipe,
    LoaderComponent,
    PopUpDirective,
    DateFormatDirective,
    BscSvgIconComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CommonModule,
    MyPrivilegesComponent,
    ModalComponent,
    LoaderComponent,
    AccessManagementPipe,
    PaginationComponent,
    SafeHtmlPipe,
    PopUpDirective,
    DateFormatDirective,
    BscSvgIconComponent
  ]
})
export class SharedModule { }
